export enum EnumMessageCenterFolders {
    INBOX = 'inbox',
    INBOX_PERSONAL = 'inbox_personal',
    INBOX_ADMINISTRATOR = 'inbox_administrator',
    ARCHIVE = 'archive',
    ARCHIVE_PERSONAL = 'archive_personal',
    ARCHIVE_ADMINISTRATOR = 'archive_administrator',
    TRASH = 'trash',
    SENT = 'sent',
}

export type EnumMessageCenterFoldersType = `${EnumMessageCenterFolders}`;